import React, {useEffect, lazy, Suspense} from "react";
import {Route, Routes, Navigate, useLocation} from "react-router-dom";
import {Toaster} from "react-hot-toast";
import {useSelector} from "react-redux";

// Utility Service
import {lazyRetry} from "./utils";

// App Update
import {useAppUpdate} from "./hooks/useappupdate";
import AppUpdateModal from "./components/modals/appupdatemodal";

// Scroll Component
import ScrollToTop from "./components/common/scrolltotop";

// Page Duration Tracker Component
import PageDurationTracker from "./components/common/pagedurationtracker";

// Auth-Service
import PrivateRoute from "./utils/privateroute";

// Redux-Functions
import {selectToken} from "./redux/userSlice";
import PrivacyAndPolicy from "./pages/content/privacyandpolicy";
import TermsAndCondition from "./pages/content/termsandcondition";

// Public Pages
const Home = lazy(() => lazyRetry(() => import("./pages/home")));
const Complex = lazy(() => lazyRetry(() => import("./pages/complex")));
const FourZeroFour = lazy(() => lazyRetry(() => import("./pages/404")));
// const ExternalRedirect = lazy(() => lazyRetry(() => import("./pages/redirect")));
function App() {
    const location = useLocation();

    const token = useSelector(selectToken);

    // App Update - shows the "new version available" modal
    const {updateAvailable, applyUpdate} = useAppUpdate();

    // Service Worker
    useEffect(() => {
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.ready.then((registration) => {
                registration.update();
            });
        }
    }, [location]);

    return (
        <>
            <ScrollToTop />
            <PageDurationTracker />
            <Toaster />
            <AppUpdateModal show={updateAvailable} onRefresh={applyUpdate} />
            <Suspense>
                <Routes>
                    {/* Home Page Route */}
                    <Route path="/" element={<Home />} />
                    {/* Complex Page Route */}
                    <Route path="/complex/:slug" element={<Complex />} />
                    <Route path="/privacy-policy" element={<PrivacyAndPolicy />} />
                    <Route path="/terms-condition" element={<TermsAndCondition />} />
                    {/* Private Route */}
                    <Route element={<PrivateRoute token={token} />}></Route>

                    {/* 404 Page Route */}
                    <Route path="/404" element={<FourZeroFour />} />

                    {/* Error Page Route */}
                    <Route path="*" element={<Navigate to="/404" replace />} />
                </Routes>
            </Suspense>
        </>
    );
}

export default App;
